import * as React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import './linkStyles.sass'

interface Props {
    label: string
    small?: boolean
    id?: string
    secondary?: boolean
    mobile?: boolean
    tertiary?: boolean
    onClick?: () => void
    className?: string
    linkUrl: string | { pathname: string; search: string }
}

const ButtonLink: React.FunctionComponent<Props> = ({
    label,
    id,
    onClick,
    secondary,
    small,
    tertiary,
    mobile,
    className,
    linkUrl
}: Props) => {
    let classname = 'link'
    if (small) classname = classname + ' link_small'
    if (mobile) classname = classname + ' link_mobile'
    if (tertiary) classname = classname + ' link_tertiary'
    if (secondary) classname = classname + ' link_secondary'
    const [t] = useTranslation()

    return (
        <span className={'linkWrapper'}>
            <Link id={id} onClick={onClick} className={className || classname} to={linkUrl}>
                {t(label)}
            </Link>
        </span>
    )
}

export default ButtonLink
